import React, { useState } from 'react'
import { TranslationProvider } from '../shared/TranslationProvider'
import CandidateProgramSurveyForm from './CandidateProgramSurveyForm'
import { CheckCircleIcon } from '@heroicons/react/24/outline'

export default function CandidateProgramSurvey({
  surveyDurationType,
  questions,
  choices,
  candidateId,
  companyId,
}) {
  const [error, setError] = useState(false)
  const [thankYou, setThankYou] = useState(false)

  if (thankYou) {
    return <ThankYouScreen surveyDurationType={surveyDurationType} />
  }

  if (error) return <ErrorScreen />

  return (
    <main>
      <TranslationProvider locale="en" translations={{}}>
        <div className="container flex w-full flex-col bg-gradient-to-b from-[#E0EFFE] to-[#E9F2E2] p-4 font-roboto max-sm:max-w-md sm:p-16 lg:max-w-full">
          <div className="mx-auto space-y-4 lg:max-w-3xl">
            <h1 className="font-roboto-slab text-2xl md:text-4xl">
              INTOO{' '}
              <span className="font-bold">
                {surveyDurationType === 'firstWeek'
                  ? 'Getting Started Survey'
                  : surveyDurationType === 'midProgram'
                    ? 'Mid-Program Check In'
                    : 'End of Program Survey'}
              </span>
            </h1>
            <p className="text-base text-[#2f2f2f]">
              As part of our commitment to ensuring your experience with INTOO
              meets the highest standards, we collect information feedback
              throughout your program.
            </p>
            {surveyDurationType === 'postProgram' && (
              <p className="text-base text-[#2f2f2f]">
                The survey below is meant to help further improve the services
                provided by INTOO.
              </p>
            )}
            <p className="text-base text-[#2f2f2f]">
              We greatly appreciate you taking the time to respond to a few
              brief questions.
            </p>
            <CandidateProgramSurveyForm
              surveyDurationType={surveyDurationType}
              questions={questions}
              choices={choices}
              candidateId={candidateId}
              companyId={companyId}
              setThankYou={setThankYou}
              setError={setError}
            />
          </div>
        </div>
      </TranslationProvider>
    </main>
  )
}

const ErrorScreen = () => {
  return (
    <div className="container flex h-screen w-full flex-col bg-gradient-to-b from-[#E0EFFE] to-[#E9F2E2] p-4 font-roboto max-sm:max-w-md sm:p-16 lg:max-w-full">
      <div className="mx-auto space-y-4 lg:max-w-3xl">
        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl/none">
          Oops, something went wrong.
        </h1>
        <p className="text-gray-500 md:text-xl dark:text-gray-400">
          We encountered an error while submitting your survey. Please try again
          later.
        </p>
      </div>
    </div>
  )
}

const ThankYouScreen = ({ surveyDurationType }) => {
  return (
    <div className="container flex h-screen w-full flex-col bg-gradient-to-b from-[#E0EFFE] to-[#E9F2E2] p-4 font-roboto max-sm:max-w-md sm:p-16 lg:max-w-full">
      <div className="mx-auto space-y-4 lg:max-w-3xl">
        <h1 className="mt-6 font-roboto-slab text-2xl md:text-4xl">
          INTOO{' '}
          <span className="font-bold">
            {surveyDurationType === 'firstWeek'
              ? 'Getting Started Survey'
              : surveyDurationType === 'midProgram'
                ? 'Mid-Program Check In'
                : 'End of Program Survey'}
          </span>
        </h1>
        <p className="text-base text-[#2f2f2f]">
          As part of our commitment to ensuring your experience with INTOO meets
          the highest standards, we collect information feedback throughout your
          program.
        </p>
        {surveyDurationType === 'postProgram' && (
          <p className="text-base text-[#2f2f2f]">
            The survey below is meant to help further improve the services
            provided by INTOO.
          </p>
        )}
        <p className="text-base text-[#2f2f2f]">
          We greatly appreciate you taking the time to respond to a few brief
          questions.
        </p>
        <div className="my-6 flex flex-col items-center space-y-4 rounded-xl bg-white p-4">
          <CheckCircleIcon className="h-8 w-8 text-green-500" />
          <h2 className="text-center text-lg font-medium text-[#2f2f2f]">
            You&lsquo;re all set!
          </h2>
          <h2 className="text-center text-lg font-medium text-[#2f2f2f]">
            Thanks for taking a moment to share your experience with us. We
            truly appreciate your time.
          </h2>
        </div>
      </div>
    </div>
  )
}
